import styled from 'styled-components';

export const SitemapBox = styled.div`
  min-height: 600px;
`;
